import { API_BASE_URL } from 'src/env';
import Ticket from 'src/interfaces/api/Ticket';
import { ApiReturnType } from 'src/interfaces/api/api';
import Intervention, { AddInterventionOptions } from 'src/interfaces/api/Intervention';
import { toQueryParamsString } from '../../utils/ApiUtils';
import { Order } from '../../interfaces/Table';

export default {
  remove: (id: Intervention['id']): ApiReturnType => ({
    endpoint: `${API_BASE_URL}/v2/ticket/interventions/${id}`,
    headers: { 'Content-Type': 'application/json' },
    method: 'DELETE',
  }),
  get: (id: Intervention['id']): ApiReturnType => ({
    endpoint: `${API_BASE_URL}/v2/ticket/interventions/${id}`,
    headers: { 'Content-Type': 'application/json' },
    method: 'GET',
  }),
  getTicketInterventions: (ticketId: Ticket['id']): ApiReturnType => ({
    endpoint: `${API_BASE_URL}/v2/ticket/tickets/${ticketId}/interventions`,
    headers: { 'Content-Type': 'application/json' },
    method: 'GET',
  }),
  getAll: (
    ticketId: Ticket['id'],
    page: number,
    limit: number,
    orderBy: keyof Intervention,
    order: Order
  ): ApiReturnType => ({
    endpoint: `${API_BASE_URL}/v2/ticket/interventions${toQueryParamsString({
      ticketId,
      page,
      limit,
      orderBy,
      order,
    })}`,
    headers: { 'Content-Type': 'application/json' },
    method: 'GET',
  }),
  create: (ticketId: Ticket['id'], interventionOptions: AddInterventionOptions): ApiReturnType => ({
    endpoint: `${API_BASE_URL}/v2/ticket/tickets/${ticketId}/interventions`,
    body: JSON.stringify(interventionOptions),
    headers: { 'Content-Type': 'application/json' },
    method: 'POST',
  }),
};
